import app from 'flarum/forum/app';
import registerWidget from '../common/registerWidget';

app.initializers.add('kemze/upcoming-events-widget', () => {
  registerWidget(app);
});
